// src/pages/PrivacyPolicy.js
import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
            <h1>Privacy Policy for ThornsDashboard</h1>
            <p><strong>Last Updated:</strong> March 13, 2025</p>

            <h2>Introduction</h2>
            <p>
                Welcome to ThornsDashboard, a dashboard application for managing inventory across multiple platforms like Shopify and eBay. This Privacy Policy explains how we collect, use, and protect your information when you use our services.
            </p>

            <h2>1. Information We Collect</h2>
            <p>We may collect the following types of information:</p>
            <ul>
                <li><strong>OAuth Data:</strong> When you authorize ThornsDashboard to access your eBay account, we collect your eBay access token to fetch inventory data on your behalf.</li>
                <li><strong>Inventory Data:</strong> We store product details (like SKU, name, price, stock) in our database to help you manage your inventory.</li>
                <li><strong>Technical Data:</strong> We may log technical information like your IP address or browser type for debugging purposes.</li>
            </ul>

            <h2>2. How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
                <li>Import and sync your inventory from platforms like eBay and Shopify.</li>
                <li>Provide you with a dashboard to manage your products.</li>
                <li>Improve our services and troubleshoot issues.</li>
            </ul>

            <h2>3. How We Protect Your Information</h2>
            <p>
                We store your data securely in a MySQL database. Access tokens are encrypted, and we use HTTPS for all communications. We do not share your data with third parties except as required to provide our services (e.g., eBay API calls).
            </p>

            <h2>4. Data Retention</h2>
            <p>
                We retain your data only as long as necessary to provide our services. You can request deletion of your data by contacting us.
            </p>

            <h2>5. Your Rights</h2>
            <p>
                Depending on your location, you may have rights to access, correct, or delete your data. Contact us to exercise these rights.
            </p>

            <h2>6. Contact Us</h2>
            <p>
                If you have questions about this Privacy Policy, please contact us at: <strong>dev@thornswarehouse.com</strong>.
            </p>
        </div>
    );
};

export default PrivacyPolicy;